import { createReducer, on } from '@ngrx/store';
import { SearchResult } from '../../models';
import * as pageActions from '../actions/search.action';
import * as utility from '../../../utility';

export interface SearchState {
  results: SearchResult[];
  magazineResults: SearchResult[];
  q: string | null;
  loaded: boolean;
  loading: boolean;
  magazineLoaded: boolean;
  magazineLoading: boolean;
  error?: any;
}

export const initialState: SearchState = {
  results: [],
  magazineResults: [],
  q: null,
  loaded: false,
  loading: false,
  magazineLoaded: false,
  magazineLoading: false,
};

export const SearchResultsReducer = createReducer(
  initialState,
  on(pageActions.GetSearchResults, (state: SearchState, { q }) => {
    return {
      ...state,
      results: [],
      q,
      loading: true,
      loaded: false,
    };
  }),
  on(pageActions.GetSearchResultsSuccess, (state: SearchState, { results }) => {
    return {
      ...state,
      results,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.GetSearchResultsFail, (state: SearchState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  }),
  on(pageActions.GetMagazineSearchResults, (state: SearchState, { q }) => {
    return {
      ...state,
      magazineResults: [],
      q,
      magazineLoaded: false,
      magazineLoading: true,
    };
  }),
  on(pageActions.GetMagazineSearchResultsSuccess, (state: SearchState, { results }) => {
    return {
      ...state,
      magazineResults: results,
      magazineLoaded: true,
      magazineLoading: false,
    };
  }),
  on(pageActions.GetMagazineSearchResultsFail, (state: SearchState, { error }) => {
    return {
      ...state,
      magazineLoaded: false,
      magazineLoading: false,
      error,
    };
  })
);

export const GetAllResults = (state: SearchState) => state.results;
export const getSearchLoading = (state: SearchState) => state.loading;
export const getSearchLoaded = (state: SearchState) => state.loaded;
export const getSearchQuery = (state: SearchState) => state.q;

export const GetAllMagazineResults = (state: SearchState) => state.magazineResults;
export const getMagazineSearchLoading = (state: SearchState) => state.magazineLoading;
export const getMagazineSearchLoaded = (state: SearchState) => state.magazineLoaded;
